import { useMutation, useQueryClient } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

export interface HolidayPostDataFormat {
  uuid: string;
  name: string;
  full_name: string;
  date: string; // Format: YYYY-MM-DD
  formatted_date?: string; // Optional, only present in some holidays
  weekday?: string; // Optional, only present in some holidays
  country_code: string;
  fixed?: boolean; // Optional, not always present
  global: boolean;
  repeat_yearly?: boolean; // Optional, not always present
}

interface IHolidayPostData {
  holidays: HolidayPostDataFormat[];
  user_ids: string[];
}

const importHolidays = (postData: IHolidayPostData) => {
  return http().post(endpoints.timeOff.importHolidays, postData);
};

export function useImportHolidays() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: importHolidays,
    onSettled: (data: any) => {
      if (data) {
        queryClient.invalidateQueries(['fetchPaginatedHolidays']);
      }
    },
  });
}
